import { Component, EventEmitter, Input, OnInit, Output, ViewEncapsulation } from '@angular/core';
import { cloneDeep } from 'lodash';
import { BUTTON, COMMON_TEXT, SCREEN_TITLE_CONFIG } from '@core/constants';
import { FilterItem } from '@core/models/models';

@Component({
  selector: 'caremoni-yotei-check-list-modal',
  templateUrl: './yotei-check-list-modal.component.html',
  styleUrls: ['./yotei-check-list-modal.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class YoteiCheckListModalComponent implements OnInit {
  COMMON_TEXT = COMMON_TEXT;
  BUTTON = BUTTON
  SCREEN_TITLE_CONFIG = SCREEN_TITLE_CONFIG
  @Input() styleModal = {}
  @Input() itemList: Array<FilterItem> = [];
  @Input() position = {};
  @Output() closeModalHandler = new EventEmitter();
  @Output() btnSaveHandler = new EventEmitter();

  isCheckAll : boolean = true

  ngOnInit(): void {
    this.itemList.forEach((x : any) =>{
      if(!x.checked){
        this.isCheckAll = false; 
        return;
      }
    })
  }

  checkItem(item: any) {
    this.itemList = this.itemList.map((x:any)=>{
      if (x.id === item.id) {
        return { ...x, checked: !x.checked };
      }
      return { ...x }; 
    });
    this.isCheckAll = true; 
    this.itemList.forEach((x : any) =>{
      if(!x.checked){
        this.isCheckAll = false; 
        return;
      }
    })
    this.itemList = cloneDeep(this.itemList);
  }

  closeModal() {
    this.closeModalHandler.emit();
  }

  onSave() {
    this.btnSaveHandler.emit(this.itemList);
    this.closeModal();
  }

  checkAll(event: any) {
    this.isCheckAll = event;
    this.itemList = this.itemList.map((x:any)=>{{
      if(event) return { ...x, checked: true };
      else return { ...x, checked: false };
    }});
    // if(event) this.itemList.forEach((x: any) => x.checked = true)
    // else this.itemList.forEach((x: any) => x.checked = false)
  }
}
